export default __webpack_public_path__ + "static/EvergreenHero-XXL-173f225571ca182f2f27401ba0f51c93.webp";